import { connect } from 'react-redux';
import queryString from 'query-string';
import Component from './ProgressGoals.component';
import { getAvatars, initStudentsRoster, getCurrentRosterYear } from '../StudentRoster/+store/studentRoster';
import { getProgressGoals, applyFilters, exportProgressGoals } from './+store/progressGoals/progressGoals.actions';
import { getSchools } from '../Settings/+store/SchoolSettings';

const isDemo = process.env.REACT_APP_THEME === 'demo';

const getIgnoreCache = () => {
  const parsedQuery = queryString.parse(window.location.search);
  return parsedQuery.cache === 'false' || false;
};

const mapStateToProps = (state) => {
  const {
    progressGoals,
    progressGoalsSummary,
    nextToken,
    filters,
    progressGoalsCSV,
    loadingCSV,
  } = state.modules.ProgressGoals.progressGoals;
  // Goal docs don't carry photoUrl, so pull it from the roster (already loaded by init)
  const roster = state.modules.StudentRoster.studentRoster.roster[getCurrentRosterYear()] || {};
  const students = progressGoals
    ? Object.entries(progressGoals).map(([firebaseId, student]) => {
        const rosterStudent = roster[firebaseId];
        return rosterStudent && rosterStudent.photoUrl
          ? [firebaseId, { ...student, photoUrl: rosterStudent.photoUrl }]
          : [firebaseId, student];
      })
    : [];
  return {
    filters,
    nextToken,
    students,
    summary: progressGoalsSummary,
    progressGoalsCSV,
    loadingCSV,
    profile: state.modules.Auth.auth.profile,
    profileUserType: state.modules.Auth.auth.profileUserType,
    username: state.modules.Auth.auth.user.uid,
    loading: state.modules.ProgressGoals.progressGoals.loadingMsg,
    errorMsg: state.modules.ProgressGoals.progressGoals.errorMsg,
    errorCode: state.modules.ProgressGoals.progressGoals.errorCode,
    loadingMore: state.modules.ProgressGoals.progressGoals.loadingMoreMsg,
    avatars: state.modules.StudentRoster.studentRoster.avatars,
  };
};

const mapDispatchToProps = (dispatch) => ({
  init: (user) => {
    dispatch(initStudentsRoster(user));
    dispatch(getAvatars());
    dispatch(getSchools(user));
  },
  getProgressGoals: (filters, nextToken) => {
    const { sortBy, ...otherFilters } = filters;
    dispatch(applyFilters(filters));
    dispatch(
      getProgressGoals({
        limit: 100,
        nextToken,
        ignoreCache: getIgnoreCache(),
        sortBy,
        filters: otherFilters,
        includeSummary: isDemo,
      })
    );
  },
  recalculateProgressGoals: (filters) => {
    const { sortBy, ...otherFilters } = filters;
    dispatch(applyFilters(filters));
    dispatch(
      getProgressGoals({
        limit: 100,
        nextToken: null,
        ignoreCache: true,
        sortBy,
        filters: otherFilters,
        includeSummary: isDemo,
      })
    );
  },
  exportProgressGoals: (filters) => {
    const { sortBy, ...otherFilters } = filters;
    dispatch(exportProgressGoals(sortBy, otherFilters));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
